// extracted by mini-css-extract-plugin
export default {"item":"webpack-concepts-Extraction-Preview-BuildPreview-module__item"};